module.exports = __webpack_public_path__ + "static/media/carta_84.65824fcd.jpg";